import Heading from "@afa-shared/afa-components/dist/Heading";
import Text from "@afa-shared/afa-components/dist/Text";
import RichTextRenderer from "@components/RichTextRenderer";
import Grid from "@components/client/Grid";

import { Context } from "types/context/Context";

import styles from "./TimelineBlock.module.css";
import { TimelineBlockType_timelineBlock } from "./queries/contentfulTypes/TimelineBlockType";
import { mapTimelineStepsToContent } from "./timelineStepMapper";

interface ITimelineBlockProps {
  blockData: TimelineBlockType_timelineBlock;
  uniqueKey?: string;
  context: Context;
}

export const TimelineBlock = ({ blockData: timelineBlock, context }: ITimelineBlockProps) => {
  const timelineContent = mapTimelineStepsToContent(timelineBlock?.stepsCollection?.items);

  return (
    <Grid
      data-blockname="tidslinje"
      data-contentful-entry-id={timelineBlock?.sys?.id}
      data-contentful-field-id="name"
    >
      {timelineBlock?.heading && (
        <Heading className={styles.heading} variant={context?.heading?.parentLevel}>
          {timelineBlock?.heading}
        </Heading>
      )}
      {timelineBlock?.text && (
        <Text className={styles.description} variant={"paragraph"} children={timelineBlock?.text} />
      )}
      <ol className={styles.timeline}>
        {timelineContent.map((item, index) => (
          <li className="container-list-item" key={item.key} data-before={index + 1}>
            <div className="content">
              <RichTextRenderer json={item.json} links={item.links} />
            </div>
          </li>
        ))}
      </ol>
    </Grid>
  );
};
export default TimelineBlock;
